import {
  createAsyncThunk,
  createEntityAdapter,
  createSlice,
} from "@reduxjs/toolkit";
import {
  createVideo,
  deleteVideo,
  getVideos,
} from "data/server_apis/adsService";

const adsVideoAdapter = createEntityAdapter({
  selectId: (ads) => ads.id,
});

export const getVideosThunk = createAsyncThunk(
  "ads/getVideos",
  async (_, { rejectWithValue }) => {
    try {
      return (await getVideos()).data;
    } catch (err) {
      console.log(err);
      const customError = {
        name: err.response?.status,
        message: err.response?.status === 400 ? err.response?.data : null,
      };
      return rejectWithValue(customError);
    }
  }
);

export const createVideoThunk = createAsyncThunk(
  "ads/createVideo",
  async (data, { rejectWithValue }) => {
    try {
      return (await createVideo(data)).data;
    } catch (err) {
      console.log(err);
      const customError = {
        name: err.response?.status,
        message: err.response?.status === 400 ? err.response?.data : null,
      };
      return rejectWithValue(customError);
    }
  }
);

export const deleteVideoThunk = createAsyncThunk(
  "ads/deleteVideo",
  async (id, { rejectWithValue }) => {
    try {
      return (await deleteVideo(id)).data;
    } catch (err) {
      console.log(err);
      const customError = {
        name: err.response?.status,
        message: err.response?.status === 400 ? err.response?.data : null,
      };
      return rejectWithValue(customError);
    }
  }
);

const AdsVideoSlice = createSlice({
  name: "ads_videos",
  initialState: adsVideoAdapter.getInitialState({
    loading: {},
    error: {},
    errorMessage: {},
    success: {},
  }),
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(createVideoThunk.pending, (state, action) => {
        state.loading = { create: true };
        state.error = {};
        state.success = {};
        state.errorMessage = {};
      })
      .addCase(createVideoThunk.rejected, (state, action) => {
        state.loading = {};
        state.error = { create: true };
        state.success = {};
        state.errorMessage = { create: action.payload?.message };
      })
      .addCase(createVideoThunk.fulfilled, (state, action) => {
        state.loading = {};
        state.error = {};
        state.success = { create: true };
        state.errorMessage = {};
        adsVideoAdapter.addOne(state, action.payload);
      });

    builder
      .addCase(getVideosThunk.pending, (state, action) => {
        state.loading = { list: true };
        state.error = {};
        state.success = {};
        state.errorMessage = {};
      })
      .addCase(getVideosThunk.rejected, (state, action) => {
        state.loading = {};
        state.error = { list: true };
        state.success = {};
        state.errorMessage = { list: action.payload?.message };
      })
      .addCase(getVideosThunk.fulfilled, (state, action) => {
        state.loading = {};
        state.error = {};
        state.success = { list: true };
        state.errorMessage = {};
        adsVideoAdapter.setAll(state, action.payload);
      });

    builder
      .addCase(deleteVideoThunk.pending, (state, action) => {
        state.loading = { delete: action.meta.arg };
        state.error = {};
        state.success = {};
        state.errorMessage = {};
      })
      .addCase(deleteVideoThunk.rejected, (state, action) => {
        state.loading = {};
        state.error = { delete: true };
        state.success = {};
        state.errorMessage = { delete: action.payload?.message };
      })
      .addCase(deleteVideoThunk.fulfilled, (state, action) => {
        state.loading = {};
        state.error = {};
        state.success = { delete: true };
        state.errorMessage = {};
        adsVideoAdapter.removeOne(state, action.meta.arg);
      });
  },
});

export const adsVideoSelector = adsVideoAdapter.getSelectors(
  (state) => state.adsVideo
);

export const {} = AdsVideoSlice.actions;

export default AdsVideoSlice.reducer;
